import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {SubscriptionPlanInfoResponse} from "../interface/subscriptionPlanInfoResponse";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPlanInfoService {

  private readonly ENDPOINT_URL = environment.apiUrl + '/subscription-plan-info';

  constructor(private http: HttpClient) {
  }

  findAll(): Observable<SubscriptionPlanInfoResponse[]> {
    return this.http.get<SubscriptionPlanInfoResponse[]>(`${this.ENDPOINT_URL}/static`);
  }

  getById(id: number): Observable<SubscriptionPlanInfoResponse> {
    const url: string = `${this.ENDPOINT_URL}/id/${id}`
    return this.http.get<SubscriptionPlanInfoResponse>(url);
  }
}
